import { useUserSettings as libUseUserSettings } from 'use-user-settings';

export const useUserSettings = <T>(
  defaultValue: T | (() => T),
  key?: string
) => {
  return libUseUserSettings(defaultValue, key, 'sp-portal-settings');
};
